import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Container } from '@material-ui/core';
import { Route, Switch } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import theme from './theme';
import HomePage from './pages/HomePage';
import AdminPage from './pages/AdminPage';
import NavBar from './components/NavBar';
import FeedbacksProvider from './contexts/FeedbacksProvider';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Switch>
        <Route exact path="/">
          {/* Loaded here so the nav bar can hide "Reviews" when there are none. */}
          <FeedbacksProvider>
            <NavBar />
            <HomePage />
          </FeedbacksProvider>
        </Route>
        <Route path="/admin">
          <Container maxWidth="lg">
            <AdminPage />
          </Container>
        </Route>
      </Switch>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 5000,
          style: { fontWeight: 600, borderRadius: 10, padding: '12px 16px' },
        }}
      />
    </ThemeProvider>
  );
}

export default App;
